import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { ExportToExcel } from './ExportToExcel';
import { Typography} from '@mui/material';
import { CardActionArea } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import Admin_access from './Admin_access';
import AdminTable from './AdminTable';
import config from "../../config.js";



const Complaint_stats = () => {
 
  const [progressStats, setProgressStats] = useState([])
  const [typeStats, setTypeStats] = useState([])
  const [completedCounts, setcompletedCounts] = useState(0)
  const [inprogressCounts, setinprogressCounts] = useState(0)
  const [underProcurementCounts, setunderProcurementCounts] = useState(0)
  const [rejectedCounts, setrejectedCounts] = useState(0)
  const [pendingCounts, setpendingCounts] = useState(0)
  const [estateCounts, setestateCounts] = useState(0)
  const [computerCounts, setcomputerCounts] = useState(0)
  const [networkingCounts, setnetworkingCounts] = useState(0)
  const [electricalCounts, setelectricalCounts] = useState(0)
  const [refridgerationCounts, setrefridgementCounts] = useState(0)
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const fileName = "nitttr_complaints";
  const userId = localStorage.getItem('userId');
  const dept = localStorage.getItem('department');
  const designation = localStorage.getItem('designation');
  const userName=localStorage.getItem('userName');

  const Tables=['Users','Complaint Types','Complaint Subtypes','Departments'];
  const [selected,isSelected]=useState(false);
  const [value,setValue]=useState(0);

  const getAOData = async (startDate, endDate) => {
    try {
      const startdate = startDate;
      const enddate = endDate;
      const response = await fetch(`${config.BASE_URL_IP}/wob/getcomplaints/${startdate}/${enddate}`,
      {
        headers:{"Content-Type":"application/json"},
        method:"GET"
      }
      );
      const jsonData = await response.json();
      setData(jsonData);
    } catch (err) {
      console.error(err.message)
    } 
  }  
  useEffect(() => {
    if (startDate && endDate) {
      getAOData(startDate, endDate);
    }
  },[startDate, endDate]);

const getComplainerStats = async () => {
  try {
    const response = await fetch(`${config.BASE_URL_IP}/wob/stats/complainer/${userId}`,
    {
      headers:{"Content-Type":"application/json"},
      method:"GET"
    }
    );
    const jsonData = await response.json();
    setProgressStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_progress'));
    setTypeStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_types'));
  } catch (err) {
    console.error(err.message)
  } 
}

useEffect(() => {
  if (progressStats.find(stat => stat.based_on_property === 'Completed') && progressStats.find(stat => stat.based_on_property === 'Completed by Complainer')) {
    setcompletedCounts(progressStats.find(stat => stat.based_on_property === 'Completed').counts + progressStats.find(stat => stat.based_on_property === 'Completed by Complainer').counts);
  }
  else if (progressStats.find(stat => stat.based_on_property === 'Completed')) {
    setcompletedCounts(progressStats.find(stat => stat.based_on_property === 'Completed').counts);
  } else if (progressStats.find(stat => stat.based_on_property === 'Completed by Complainer')) {
    setcompletedCounts(progressStats.find(stat => stat.based_on_property === 'Completed by Complainer').counts);
  }
  if (progressStats.find(stat => stat.based_on_property === 'inProgress')) {
    setinprogressCounts(progressStats.find(stat => stat.based_on_property === 'inProgress').counts);
  }
  if (progressStats.find(stat => stat.based_on_property === 'Pending') && progressStats.find(stat => stat.based_on_property === 'Pending-justification given')) {
    setpendingCounts(progressStats.find(stat => stat.based_on_property === 'Pending').counts + progressStats.find(stat => stat.based_on_property === 'Pending-justification given').counts);
  }
  else if (progressStats.find(stat => stat.based_on_property === 'Pending')) {
    setcompletedCounts(progressStats.find(stat => stat.based_on_property === 'Pending').counts);
  } else if (progressStats.find(stat => stat.based_on_property === 'Pending-justification given')) {
    setcompletedCounts(progressStats.find(stat => stat.based_on_property === 'Pending-justification given').counts);
  }
  if (progressStats.find(stat => stat.based_on_property === 'Rejected By HOD') && progressStats.find(stat => stat.based_on_property === 'Rejected By Director')) {
    setrejectedCounts(progressStats.find(stat => stat.based_on_property === 'Rejected By HOD').counts + progressStats.find(stat => stat.based_on_property === 'Rejected By Director').counts);
  }
  else if (progressStats.find(stat => stat.based_on_property === 'Rejected By HOD')) {
    setcompletedCounts(progressStats.find(stat => stat.based_on_property === 'Rejected By HOD').counts);
  } else if (progressStats.find(stat => stat.based_on_property === 'Rejected By Director')) {
    setcompletedCounts(progressStats.find(stat => stat.based_on_property === 'Rejected By Director').counts);
  }
  if (progressStats.find(stat => stat.based_on_property === 'Under Procurement')) {
    setunderProcurementCounts(progressStats.find(stat => stat.based_on_property === 'Under Procurement').counts);
  }
  if (typeStats.find(stat => stat.based_on_property === 'COMPUTER NETWORKING / TELEPHONE')) {
    setnetworkingCounts(typeStats.find(stat => stat.based_on_property === 'COMPUTER NETWORKING / TELEPHONE').counts);
  }
  if (typeStats.find(stat => stat.based_on_property === 'ELECTRICAL MAINTENANCE')) {
    setelectricalCounts(typeStats.find(stat => stat.based_on_property === 'ELECTRICAL MAINTENANCE').counts);
  }
  if (typeStats.find(stat => stat.based_on_property === 'REFRIGERATION AND AIR CONDITIONING MAINTENANCE')) {
    setrefridgementCounts(typeStats.find(stat => stat.based_on_property === 'REFRIGERATION AND AIR CONDITIONING MAINTENANCE').counts);
  }
  if (typeStats.find(stat => stat.based_on_property === 'ESTATE - CIVIL MAINTENANCE')) {
    setestateCounts(typeStats.find(stat => stat.based_on_property === 'ESTATE - CIVIL MAINTENANCE').counts);
  }
  if (typeStats.find(stat => stat.based_on_property === 'COMPUTER MAINTENANCE')) {
    setcomputerCounts(typeStats.find(stat => stat.based_on_property === 'COMPUTER MAINTENANCE').counts);
  }
}, [progressStats, typeStats]);

const getHodStats = async () => {
  try {
    const response = await fetch(`${config.BASE_URL_IP}/wob/stats/hod/${dept}`,
    {
      headers:{"Content-Type":"application/json"},
      method:"GET"
    }
    );
    const jsonData = await response.json();
    setProgressStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_progress'));
    setTypeStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_types'));
  } catch (err) {
    console.error(err.message)
  } 
}

const getDirectorStats = async () => {
  try {
    const response = await fetch(`${config.BASE_URL_IP}/wob/stats/director`,
    {
      headers:{"Content-Type":"application/json"},
      method:"GET"
    }
    );
    const jsonData = await response.json();
    setProgressStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_progress'));
    setTypeStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_types'));
  } catch (err) {
    console.error(err.message)
  } 
}

const getSupervisorStats = async () => {
  try {
    const response = await fetch(`${config.BASE_URL_IP}/wob/stats/supervisor/${dept}`,
    {
      headers:{"Content-Type":"application/json"},
      method:"GET"
    }
    );
    const jsonData = await response.json();
    setProgressStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_progress'));
    setTypeStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_types'));
  } catch (err) {
    console.error(err.message)
  } 
}

const getTechnicianStats = async () => {
  try {
    const response = await fetch(`${config.BASE_URL_IP}/wob/stats/technician/${userId}`,
    {
      headers:{"Content-Type":"application/json"},
      method:"GET"
    }
    );
    const jsonData = await response.json();
    setProgressStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_progress'));
    setTypeStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_types'));
  } catch (err) {
    console.error(err.message)
  } 
}

const getAdminStats = async () => {
  try {
    const response = await fetch(`${config.BASE_URL_IP}/wob/get_all_users`,
    {
      headers:{"Content-Type":"application/json"},
      method:"GET"
    }
    );
    const jsonData = await response.json();
    setProgressStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_progress'));
    setTypeStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_types'));
  } catch (err) {
    console.error(err.message)
  } 
}

const getAOOfficerStats = async () => {
  try {
    const response = await fetch(`${config.BASE_URL_IP}/wob/stats/director`,
    {
      headers:{"Content-Type":"application/json"},
      method:"GET"
    }
    );
    const jsonData = await response.json();
    setProgressStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_progress'));
    setTypeStats(jsonData.filter(stat => stat.table_name === 'nitttr_complaint_types'));
  } catch (err) {
    console.error(err.message)
  } 
}

  useEffect(()=>{
    if(designation === 'Complainer')
    {
      getComplainerStats();
    }
    else if (designation === 'Head of department')
    {
      getHodStats();
    }
    else if (designation === 'Director')
    {
      getDirectorStats();
    }
    else if (designation === 'Supervisor')
    {
      getSupervisorStats();
    }
    else if (designation === 'Technician')
    {
      getTechnicianStats();
    }
    else if (designation === 'Admin')
    {
      getAdminStats();
    } else if (designation === 'AO Officer') {
      getAOOfficerStats();
    }
  },[]);

  const handleCardClick = (index) =>{
    isSelected(true);
    setValue(index+1);
  }
  if(selected)
    {
      return(<AdminTable value={value} changeSelect={isSelected}/>)
    }

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  return (
    <>
    { (designation !== 'Admin') && (
    <>
      <div style={{ padding: '16px', textAlign: 'center' }}>
        <Typography variant="h1" component="h2" align="center" gutterBottom>
        {designation}'s Work-Orders
        </Typography>
      </div>
      
      {designation === 'AO Officer' && (
        <div>
        <label htmlFor="datepicker">Select a Start Date:</label>
        <input 
          type="date" 
          id="datepicker" 
          name="datepicker" 
          value={startDate} 
          onChange={handleStartDateChange} 
          style={{
            marginLeft:"10px"
          }}
        />
        <label htmlFor="datepicker" style={{
          marginLeft:"10px"
        }}>Select an End Date:</label>
        <input 
          type="date" 
          id="datepicker" 
          name="datepicker" 
          value={endDate} 
          onChange={handleEndDateChange} 
          style={{
            marginLeft:"10px"
          }}
        />
        {startDate && (
          <p>Your selected Start Date: {startDate}</p>
        )}
        
        {endDate && (
          <p>Your selected End Date: {endDate}</p>
        )}
      </div>
      )}
      {data.length > 0 && designation === 'AO Officer' && (
        <ExportToExcel apiData={data} fileName={fileName}  />
      )}
      <div style={{ display: 'flex', maxWidth: '1200px', margin: '0 auto', padding: '16px', gap: '16px' }}>
        <div style={{ flex: 1, borderRight: '1px solid #ddd', paddingRight: '16px' }}>
          <Typography variant="h2" component="h2" gutterBottom align="center">
            Statistics based on the Work Order Types
          </Typography>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px', marginBottom: '25px' }}>
              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: '#29315A',
                  color: 'white',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                    ESTATE - CIVIL MAINTENANCE
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {estateCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: 'white',
                  color: 'black',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                    ELECTRICAL MAINTENANCE
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {electricalCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: '#29315A',
                  color: 'white',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                    REFRIGERATION AND AIR CONDITIONING MAINTENANCE
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {refridgerationCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: 'white',
                  color: 'black',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                    COMPUTER MAINTENANCE
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {computerCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: '#29315A',
                  color: 'white',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                    COMPUTER NETWORKING / TELEPHONE
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {networkingCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
          </div>
        </div>

        <div style={{ flex: 1, paddingLeft: '16px' }}>
          <Typography variant="h2" component="h2" gutterBottom align="center">
            Statistics based on the Work Order Status
          </Typography>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px', marginBottom: '25px' }}>
            
              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: 'white',
                  color: 'black',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      COMPLETED
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {completedCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>

              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: '#29315A',
                  color: 'white',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      INPROGRESS
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {inprogressCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: 'white',
                  color: 'black',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      PENDING
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {pendingCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: '#29315A',
                  color: 'white',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      UNDER PROCUREMENT
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {underProcurementCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
              <Card 
                style={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                  flexBasis: 'calc(25% - 8px)', // 25% width with 8px gap
                  backgroundColor: 'white',
                  color: 'black',
                  marginBottom: '16px', // adjust as needed
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      REJECTED
                    </Typography>
                    <Typography variant="body2" align='center'>
                      {rejectedCounts}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
          </div>
        </div>
      </div>
    </>
      ) }
    {
      (designation === 'Admin') && (
        <>
          <div style={{ padding: '16px', textAlign: 'center' }}>
            <Typography variant="h1" component="h2" align="center" gutterBottom>
              Tables
            </Typography>
          </div>
          
          <div style={{ display: 'flex', maxWidth: '1200px', margin: '0 auto', padding: '16px', gap: '16px' }}>
            <div style={{ flex: 1, borderRight: '1px solid #ddd', paddingRight: '16px' }}>
              <Typography variant="h2" component="h2" gutterBottom align="center">
                Edit or Update Data
              </Typography>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px', marginBottom: '25px' }}>
                {Tables.map((stat, index) => (
                  <Card 
                    key={index} 
                    sx={{ minWidth: 220, flex: '1 1 calc(25% - 1rem)',
                      backgroundColor: index % 2 === 0 ? '#29315A' : 'white',
                      color: index % 2 === 0 ? 'white' : 'black'
                    }}
                  >
                    <CardActionArea onClick={() => handleCardClick(index)}>
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          {stat}
                        </Typography>
                        {/* <Typography variant="body2">
                          {stat.counts}
                        </Typography> */}
                      </CardContent>
                    </CardActionArea>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </>
          )
    }
    </>
  )
}

export default Complaint_stats
